import React from 'react';
export default {
  'cart': {
    'change-currency': 'Zmień walutę',
    'and-then': 'A potem',
    'plus-tax': ' + podatek',
    'for': 'Za',
    'edit': {
      'label': 'Edytuj',
      'submit': 'Zastosuj'
    },
    'empty': 'Na razie nie dodano niczego do zamówienia.',
    'free': 'darmowe',
    'promo-code': {
      'add': 'Dodaj kartę upominkową lub kod promocyjny',
      'error': {
        'invalid-for-subscription': 'Kod kuponu nie jest ważny dla tego zamówienia.'
      },
      'label': 'Karta upominkowa lub kod promocyjny',
      'submit': 'Zastosuj'
    },
    'subtotal-line': {
      'tax-label': 'Szacowany podatek',
      'subtotal': 'Podsuma',
      'tax': 'Podatek',
      'gift-card': 'Karta podarunkowa'
    },
    'starting-price': 'Cena wywoławcza',
    'title': 'podsumowanie zamowienia',
    'setup-fee': 'opłata instalacyjna',
    'free-trial': 'Bezpłatna wersja próbna',
    'total-line': {
      'label': 'Całość'
    },
    'order-total-line': {
      'label': 'Całość Zamówienia'
    }
  },
  'address': {
    'country': 'Kraj',
    'address2': 'Numer mieszkania itp.',
    'tax-identifier': 'Identyfikator podatkowy',
    'tax-identifier-type': 'Typ identyfikatora podatkowego',
    'first-name': 'Imię',
    'last-name': 'nazwisko',
    'company-name': 'Nazwa firmy',
    'address1': 'Adres ulicy',
    'city': 'Miasto',
    'state': 'stan',
    'postal-code': 'Kod pocztowy',
    'phone-number': 'numer telefonu',
    'vat-number': 'Numer VAT/ID podatkowe'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Dane karty',
      'expiry': 'MM/RR',
      'name': 'Karta Kredytowa',
      'number': 'Numer karty',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'konto bankowe',
      'routing-number': 'Numer rozliczeniowy',
      'account-number': 'Numer konta',
      'account-number-confirmation': 'Potwierdź numer konta',
      'account-type': {
        'label': 'Typ konta',
        'checking': 'kontrola',
        'savings': 'oszczędności'
      },
      'name-on-account': 'Nazwa konta'
    },
    'amazon': {
      'name': 'Amazon Pay'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Kod Sort'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'Kod BSB'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'ideał'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Adres rozliczeniowy',
  'billing-address-same-as-shipping': 'Taki sam jak adres wysyłki',
  'submit': 'Zapłać teraz',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>Wybrano {paymentMethod}</>,
  'express-checkout': 'Ekspresowa kasa',
  'change-payment-method': 'Zmień metodę płatności',
  'day': 'dzień',
  'days': 'dni',
  'week': 'tydzień',
  'weeks': 'tygodnie/tygodni',
  'month': 'miesiąc',
  'months': 'miesiące/miesięcy',
  'year': 'rok',
  'years': 'lata/lat',
  'confirmation': {
    'title': 'Dziękujemy za złożenie zamówienia',
    'order-num': ({ number }: { number: number }) => <>Zamówienie nr {number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Złożone dnia {date}</>,
    'email-notice': 'Otrzymasz mailowe potwierdzenie złożenia zamówienia.',
    'payment': 'Zapłata',
    'return-to': ({ name }: { name: string }) => <>Wróć do {name}</>,
    'credit-applied': 'Kredyt Zastosowany'
  },
  'back': 'Wróć',
  'contact-info': 'Informacje kontaktowe',
  'email-address': 'E-mail',
  'payment-info': 'Informacje rozliczeniowe',
  'shipping-address': 'adres wysyłki',
  'legal': {
    'accept': 'Akceptuję',
    'privacy-policy': 'Polityka prywatności',
    'terms-of-service': 'Warunki usługi'
  },
  'recurring': {
    'consent': `Zgadzam się na regulowanie powyższych opłat wyświetlanych z częstotliwością fakturowania,
                na zasadzie automatycznego odnawiania, chyba że subskrypcja zostanie anulowana przed końcem
                bieżącego okresu rozliczeniowego.`,
    'cancel': 'Aby anulować subskrypcję, przejdź na stronę Zarządzanie kontem.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'dzień' : 'dni',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'tydzień' : 'tygodnie',
    'months': ({ count }: { count: number }) => count === 1 ? 'miesiąc' : 'miesięcy',
    'years': ({ count }: { count: number }) => count === 1 ? 'rok' : 'lat'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>Zostanie naliczona opłata {amount}/jednostkę za {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>Zostanie naliczona opłata {amount} za {units} {unitsLabel} z {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>Począwszy od {startDate} zostanie naliczona opłata {amount}/{intervalLengthLabel}{taxable ? ' + podatek' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>Począwszy od {startDate} zostanie naliczona opłata {amount}/{intervalLengthLabel}{taxable ? ' + podatek' : ''}, wraz z jednorazową opłatą {setupFee}</>,
      'cancellation.reminder': 'Otrzymasz przypomnienie e-mail {days} dni przed rozpoczęciem rozliczania.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>Twoja bezpłatna wersja próbna {trialLength} {trialInterval} rozpoczyna się dzisiaj.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Aby uniknąć naliczenia opłat, musisz anulować przed {trialEndsAt}.</>,
      'email.reminder': ({ days }: { days: number }) => <>Otrzymasz przypomnienie e-mail {days} dni przed rozpoczęciem rozliczania</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Twoja subskrypcja zakończy się {billingEndsAt} i nie będzie automatycznie odnawiana.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>Po {afterChargeTime} zostanie naliczona opłata {newChargeAmount} + podatek</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Twoja subskrypcja będzie automatycznie odnawiana co {totalCyclesLengthLabel} i będzie kontynuowana do momentu anulowania.</>,
      'title': 'Szczegóły subskrypcji',
    },
    'agreement.button': 'Akceptuj i Kontynuuj',
    'agreement.text': 'Klikając "Akceptuj i Kontynuuj", potwierdzasz, że rozumiesz i akceptujesz te warunki subskrypcji. Żadne opłaty nie będą naliczone do zakończenia płatności.',
    'changeOrCancel': 'Aby zmienić lub anulować subskrypcję ',
    'access-account': 'uzyskaj dostęp do swojego konta',
    'contact-support': 'skontaktuj się z pomocą techniczną',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' i ',
      'lastWordConnector': ' oraz '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Rozliczenia subskrypcji obsługiwane przez {recurly}</>,
  'errors': {},
  'subscribe': 'Subskrybuj'
};
